import '../styles/main.scss';
import { elements } from './base';
import { elementsStrings } from './base';

import objectFitPolyfill from 'objectFitPolyfill';



// import arrowRight from '../assets/images/arrow_right.png';
// import backArea from '../assets/images/back_img.jpg';
// import backArea2 from '../assets/images/terms_background.jpg';
// import circle1 from '../assets/images/circle1.png';
// import detailsBorder from '../assets/images/details_border.png';
// import diamond from '../assets/images/diamond.png';
// import diamond2 from '../assets/images/diamond_green.png';
// import diamond3 from '../assets/images/diamond_green-big.png';
// import diamond4 from '../assets/images/diamond_red.png';
// import diamond5 from '../assets/images/diamond_yellow.png';
// import bar from '../assets/images/game_bar.png';
// import gameLogo from '../assets/images/game_logo.png';
// import logoLV from '../assets/images/logo.png';
// import pkt from '../assets/images/pkt1.png';
// import gamePrev1 from '../assets/images/preview_game1.png';
// import gamePrev2 from '../assets/images/preview_game2.png';
// import gamePrev3 from '../assets/images/preview_game3.png';
// import spin1 from '../assets/images/spin_basic.png';
// import spin2 from '../assets/images/spin_standard.png';
// import spin3 from '../assets/images/spin_premium.png';
// import spin4 from '../assets/images/spin_mega.png';
// import star1 from '../assets/images/star_big.png';
// import star2 from '../assets/images/star_big2.png';
// import star3 from '../assets/images/star_micro.png';
// import star4 from '../assets/images/star_small.png';


const { hamburger,
    backdrop,
    nav,
    header,
    logo,
    btn,
    btnBox,
    termsBackdrop,
    termsLastItem,
    stars} = elements;



const { hamburgerActive,
    backdropActive,
    navMobile,
    navHide,
    backdropTermsActive,
    showTermsItem,
} = elementsStrings;

let hidden = true;

stars.forEach((star)=>{
    // console.dir(star.style);
    star.style.animationDuration =`${Math.random()+3.5}s`;
    // console.log(star.style.animationDuration);
    star.style.animationDelay = `${Math.floor(Math.random() * (6 - 1 + 1)) + 1}s`
    // console.log(star.style.animationDelay);
})

btn.addEventListener('click', (e)=>{
    e.preventDefault()


    if(hidden) {
        hidden = !hidden;
        termsBackdrop.classList.toggle(backdropTermsActive);
        termsLastItem.classList.toggle(showTermsItem);
        btn.textContent = 'hide';

    } else {
        btn.textContent = 'expand';
        hidden = !hidden;
        termsLastItem.classList.toggle(showTermsItem);
        termsBackdrop.classList.toggle(backdropTermsActive);

    }
});



hamburger.addEventListener('click', ()=> {
    hamburger.classList.toggle(hamburgerActive);
    backdrop.classList.toggle(backdropActive);
    header.classList.toggle(navMobile);
    nav.classList.toggle(navHide);

});